import { render, staticRenderFns } from "./CuButton.vue?vue&type=template&id=4f13e83e"
import script from "./CuButton.vue?vue&type=script&lang=js"
export * from "./CuButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports